import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { Flow, PostFlow, PutFlow } from 'src/app/interfaces/api/flow';
import { environment } from 'src/environments/environment';
import { ApiService } from '../../core/api.service';
import { RequestService } from '../../core/request.service';
import { WebSocketService } from '../../core/web-socket.service';

type QueryParams = Record<string, string | number | boolean | Date | Array<string | number | boolean | Date> | object>;

@Injectable({
  providedIn: 'root'
})

export class FlowService {

  collection = "Flow";
  collectionPath = "flows";
  flows: Flow[] = [];
  apiUrl = environment.API_URL;
  flowUrl = environment.FLOW_URL;
  replayUrl = environment.FLOW_REPLAY_URL;

  constructor(
    public http: HttpClient,
    private request: RequestService,
    private socket: WebSocketService,
    private apiService: ApiService,
  ) { }
  //Manque les sockets sur unifield-flow sur le deployed afin d'update les flows en temps réel
  //---GET---//

  getLastFlows(query: QueryParams = {}): Observable<Flow[]> {
    return concat(
      this.request.getCollection(this.collection, this.collectionPath, query, "last"),
      this.socket.getUpdate(this.collection)
    )
  }

  getFlows(query: QueryParams = {}, projectId: string = "", key: string = ""): Observable<Flow[]> {
    let options: { headers?: HttpHeaders } = {};

    if (projectId && key) {
      options["headers"] = new HttpHeaders({
        'x-access-key': key,
        'x-project-id': projectId
      })
    }

    return this.apiService.getCollection(this.collectionPath, "", query, options)
  }

  getFlow(id: string): Observable<Flow> {
    return this.apiService.getCollectionItem(this.collectionPath, "", id)
  }

  getCompactFlowsTemplate(database: string): Observable<any> {
    return this.apiService.getCollection(this.collectionPath, 'templates', { database });
  }

  getCompactFlow(): Observable<any> {
    return this.apiService.getCollection(this.collectionPath, 'templates');
  }

  startFlow(database: string): Observable<any> {
    return this.http.get(`${this.flowUrl}/workflows/api/flows/start?database=${database}`);
  }

  stopFlow(database: string): Observable<any> {
    return this.http.get(`${this.flowUrl}/workflows/api/flows/stop?database=${database}`);
  }

  refreshFlow(query: any): Observable<any> {
    return this.http.get(`${this.replayUrl}/workflows/api/replay/refresh?${query}`)
  }

  playFlow(query: any): Observable<any> {
    return this.http.get(`${this.replayUrl}/workflows/api/replay/load?${query}`)
  }

  stopReplay(query: any): Observable<any> {
    return this.http.get(`${this.replayUrl}/workflows/api/replay/kill?${query}`)
  }

  //---POST---//

  deployFlow(flow: QueryParams): Observable<any> {
    return this.http.post(`${this.flowUrl}/workflows/api/flows`, flow);
  }

  addFlow(flow: PostFlow): Observable<any> {
    return this.request.postItem(this.collection, this.collectionPath, flow);
  }

  //---PUT---//

  updateFlow(flow: PutFlow): Observable<any> {
    return this.request.setProjectData(this.collection, this.collectionPath, flow);
  }

  //---DELETE---//

  removeFlow(id: string): Observable<any> {
    return this.request.deleteItem(this.collection, this.collectionPath, id);
  }
}
